import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { setting } from '../../../../setting';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ChangepassService {
  public apiBookingUrl :string;

  constructor(private http: HttpClient) {
    this.apiBookingUrl  = setting.apiBookingUrl;
  }

  public resetPassword(data: any): Observable<any> {
    let json = JSON.stringify(data);

    return this.http
      .post<any>(`${this.apiBookingUrl}userResetPassword`, json)
      .pipe(
        tap((response) => {
          const success = response.status;
          const message = response.message;
          if (success) {
            // lógica para mostrar mensaje de éxito y recargar página
          } else if (response instanceof HttpErrorResponse) {
            // lógica para mostrar mensaje de error de HTTP
          } else {
            // lógica para mostrar mensaje de error
          }
        })
      );
  }



}



